

import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button, Image, Layout, Menu, Tooltip } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DashboardSvg, DeviceSvg, LogoutIcon, RoleSvg, SubscriptionSvg, UsersSvg } from 'utils/svgs';
import { toastText } from 'utils/utils';
import { logoutAction } from '../../../redux/actions/logoutAction';
import { clearProfileRedux } from '../../../redux/slices/profileSlice';
import styles from './index.module.scss';
import './index.scss';
import { SidebarProps } from './types';

const { Sider } = Layout;

const getKeyWiseIcons = {
	users: <UsersSvg />,
	roles: <RoleSvg />,
	company: <RoleSvg/>,
	dashboard: <DashboardSvg />,
	device: <DeviceSvg />,
	subscription: <SubscriptionSvg />,
};

const getSelectedKeyWiseIcons = {
	users: <UsersSvg isSelected={true} />,
	roles: <RoleSvg isSelected={true} />,
	company: <RoleSvg isSelected={true} />,
	dashboard: <DashboardSvg isSelected={true} />,
	device: <DeviceSvg isSelected={true} />,
	subscription: <SubscriptionSvg isSelected={true} />,
};

const Sidebar: FC<SidebarProps> = ({ handleSidebar, items, selectedSidebar }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [collapsed, setCollapsed] = useState(false);
	const [itemsList, setItemsList] = useState(items);

	useEffect(() => {
		const updatedList = items?.map((item: any) => {
			const isSelected = item?.key === selectedSidebar;
	
			const rawIcon =
				isSelected
					? getSelectedKeyWiseIcons[item.key as keyof typeof getSelectedKeyWiseIcons]
					: getKeyWiseIcons[item.key as keyof typeof getKeyWiseIcons];
	
			// Wrap icon with Tooltip if sidebar is collapsed
			const icon = collapsed ? (
				<Tooltip title={item.label} placement="right">
					<span style={{ display: 'inline-flex', alignItems: 'center' }}>
						{rawIcon}
					</span>
				</Tooltip>
			) : (
				rawIcon
			);
	
			// Hide label when collapsed
			const label = collapsed ? undefined : item.label;
	
			return {
				...item,
				icon,
				label,
			};
		});
	
		setItemsList(updatedList);
	}, [selectedSidebar, items, collapsed]);
	

	const logoutHandler = async () => {
		// setIsLogoutLoading(true);
		// setIsLogoutLoading(false);
		try {
			
			const response = await dispatch(logoutAction() as any);

			dispatch(clearProfileRedux());
			toastText(response?.payload?.message, 'success');
			navigate('/login');
		} catch (error: any) {
			toastText(error.response.data?.message, 'error');
			localStorage.clear();
		} finally {
			localStorage.removeItem('accessToken');
		}
	};

	return (
		<Sider
			style={{
				background: '#fff',
				maxHeight: '100%',
				height: '100%',
				overflow: 'auto',
			}}
			collapsible
			trigger={null}
			collapsed={collapsed}
			collapsedWidth={80}
			className={styles.sidebar}
		>
			<div className={styles.sidebar__wrapper}>
				<div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							marginBottom: '2rem',
							marginTop: '2rem',
						}}
					>
						{!collapsed && (
							<Image
								src="/assets/images/pay2power1.png"
								preview={false}
								alt="group"
								height={30}
							/>
						)}
						<Button
							type="text"
							icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
							onClick={() => setCollapsed(!collapsed)}
							style={{
								fontSize: '16px',
								width: 32,
								height: 32,
								marginLeft: !collapsed ? 12 : 0, // optional spacing between image and button
							}}
						/>
					</div>

					<Menu
						mode="vertical"
						selectedKeys={[selectedSidebar]}
						defaultSelectedKeys={[selectedSidebar]}
						items={itemsList}
						onClick={handleSidebar}
						className="menu-item"
						style={{
							background: '#fff',
							padding: 0,
							marginBottom: '2rem',
						}}
					/>
				</div>
				<div style={{ marginBottom: '0.5rem', padding: '1rem' }}>
					<Button
						block
						type="text"
						icon={null}
						className={"no-hover-bg"}
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							gap: 8,
							paddingBottom: '0.5rem',
							paddingTop: '0.5rem'
						}}
						onClick={() => logoutHandler()}
					>
						<LogoutIcon />
						{!collapsed && 'Logout'}
					</Button>
				</div>

			</div>
		</Sider>
	);
};

export default Sidebar;
